export function GetFormattedDate(date) {
    if (typeof date === 'string') {
        date = new Date(date)
    }
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    return year + '-' + month + '-' + day;
}